import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Option } from '../../classes';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {
  constructor(private db: AngularFireDatabase) {}
  fromAToB(
    refOrPath: string | firebase.database.Reference,
    from: number | string | boolean = undefined,
    to: number | string | boolean = undefined
  ): Promise<any> {
    const ref =
      typeof refOrPath === 'string'
        ? this.db.database.ref(refOrPath)
        : refOrPath;
    return new Promise((resolve, reject) => {
      ref.transaction(
        v_o => {
          if (v_o === null) {
            return null;
          } else if (typeof from === 'undefined' || v_o === from) {
            return to;
          } else {
            return undefined;
          }
        },
        (error, committed, snapshot) => {
          if (error) {
            reject(error);
          } else if (!committed) {
            reject('transaction has not committed.');
          } else {
            resolve(snapshot.val());
          }
        }
      );
    });
  }
  set(refOrPath: string | firebase.database.Reference, value): Promise<any> {
    const ref =
      typeof refOrPath === 'string'
        ? this.db.database.ref(refOrPath)
        : refOrPath;
    return ref.set(value);
  }
  getReplyRef(survey_id: string): firebase.database.Reference {
    return this.db.database.ref(`reply/${survey_id}`);
  }
  getAgainstQuotaRef(option: Option): firebase.database.Reference {
    const s_id = option.question.survey.id,
      q_id = option.question.id,
      o_id = option.id;
    return this.db.database.ref(
      `transaction/${s_id}/filled_up_to/${q_id}/${o_id}`
    );
  }
  getCheckRef(option: Option, as: string): firebase.database.Reference {
    const s_id = option.question.survey.id,
      q_id = option.question.id,
      o_id = option.id;
    return this.db.database.ref(
      `transaction/${s_id}/check/${as}/${q_id}/${o_id}`
    );
  }
  getConcurrencyRef(s_id: string, as: string): firebase.database.Reference {
    return this.db.database.ref(
      `transaction/${s_id}/againset_concurrency/${as}`
    );
  }
}
